import { render, staticRenderFns } from "./leifeng-daily.vue?vue&type=template&id=67440202&scoped=true"
import script from "./leifeng-daily.vue?vue&type=script&lang=js"
export * from "./leifeng-daily.vue?vue&type=script&lang=js"
import style0 from "./leifeng-daily.vue?vue&type=style&index=0&id=67440202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67440202",
  null
  
)

export default component.exports